import { InitClient, GetByParas, Post, PostWithParas, PostNoParas } from "../ZeusAPIClient.js"
import { apiConfig } from "../../config.js"
import { PagingBody } from "../Model/PagingBody"
import { Predicate } from "../Model/Predicate"
InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);
//获取单个字典
async function GetSingleSysItem(id) {
    var paras = { id: id };
    return await GetByParas("4e5619fe-b447-4025-804e-a563bf8097a5", paras);
}
//根据父级ID获取字典列表
async function GetSysItemByParentID(id) {
    var paras = { parentid: id };
    return await GetByParas("3bf6dc34-2ad7-4c24-a345-507a20c666bc", paras);
}


//获取SysItem类别
async function GetSysItemListByParentID(parentId) {
    var data = { parentid: parentId }
    return await GetByParas('3bf6dc34-2ad7-4c24-a345-507a20c666bc', data);
}

//获取中心下岗位
async function GetSysItemListByFrameID(frameid) {
    var data = { frameid: frameid }
    return await GetByParas('0549c505-1523-41a6-9444-b507d7cc8af2', data);
}

export {
    GetSingleSysItem,
    GetSysItemByParentID,
    GetSysItemListByParentID,
    GetSysItemListByFrameID
}